// extracted by mini-css-extract-plugin
module.exports = {"component":"page-progress-loader_component__h_yvS","isVisible":"page-progress-loader_isVisible__UHsRr","isDone":"page-progress-loader_isDone__UKA1b"};